import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import {
    IconButton,
    Popover,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { EditionListStyle } from '../../styles/EditionListStyle';
import { I18n } from 'aws-amplify';
import OverFlowTooltip from '@/component/common/OverFlowTooltip';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import { hasStatusOnSales, onClickChangeStatusVersion, onDeletedVersionItem } from '../../handler/EditionListHandler';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import { cloneDeep } from 'lodash';

export default function VersionList({
    listVersionData,
    edition,
    onOpenVersionList,
    nameProduct,
    setListVersionUpdated,
    setIsEdit,
    setListStatusEditionDisabled,
    setEditionList
}) {
    const classes = EditionListStyle();
    const [showActionVersion, setShowActionVersion] = useState(null);
    const [actionVersionId, setActionVersionId] = useState();
    const [listVersion, setListVersion] = useState([]);
    const [showPopUpDelete, setShowPopUpDelete] = useState({ isOpen: false });

    useEffect(() => {
        let cloneListVersion = cloneDeep(listVersionData);
        let listVersionClone = Utils.sortByCreatedAtDesc(cloneListVersion);
        
        setListVersion(listVersionClone);
    }, [listVersionData]);

    useEffect(() => {
        setListStatusEditionDisabled(prevState => {
            let newInputs = [...prevState];

            if(Utils.isEmptyArray(listVersion)) {
                newInputs = [...newInputs, edition.id];
                return newInputs;
            }

            let hasOnSales = hasStatusOnSales(listVersion);

            if (!hasOnSales && !newInputs.includes(edition.id)) {
                newInputs = [...newInputs, edition.id];
                return newInputs;
            }
            
            if (hasOnSales) {
                const index = newInputs.indexOf(edition.id);
                if (index > -1) {
                    newInputs.splice(index, 1);
                }
                return newInputs;
            }
            return newInputs;
        });
    }, [listVersion]);

    const handleClickActionVersion = (event, id) => {
        setShowActionVersion(event.currentTarget);
        setActionVersionId(id);
    };

    const isShowActionVersion = Boolean(showActionVersion);

    const handleCloseActionVersion = () => {
        setShowActionVersion(null);
    };

    const getStatusItem = (item, onClick) => {
        if (Utils.isEmptyObject(item)) return null;
        if (item.status === ProductManagementConstant.STATUS.ON_SALES) {
            return (
                <div className="name-prod-status" onClick={event => onClick(event, item.id)}>
                    {I18n.get('CM-DROPDOWN-ON_SALE')}
                </div>
            );
        }
        if (item.status === ProductManagementConstant.STATUS.INTERNAL_SALE) {
            return (
                <div
                    className="status-internal-sales status-sales-item"
                    onClick={event => onClick(event, item.id)}
                >
                    {I18n.get('CM-DROPDOWN-INTERNAL-SALE')}
                </div>
            );
        }
        return (
            <div
                className="name-prod-status status-inactive-sales"
                onClick={event => onClick(event, item.id)}
            >
                {I18n.get('CM-DROPDOWN-INACTIVE-SALE')}
            </div>
        );
    };

    const renderListVersion = () => {
        return (
            listVersion &&
            listVersion?.map((version, index) => {
                if (version.isDeleted) {
                    return <></>;
                }
                return (
                    <TableRow key={version.id}>
                        <TableCell>
                            <OverFlowTooltipWithTabsMui
                                value={Utils.getTextByLanguage(
                                    Constant.LANGUAGE_TYPE.JP,
                                    version.name
                                )}
                                className={classes.tableCellItemVersion}
                            />
                        </TableCell>
                        <TableCell>
                            <a className="hyper-link" target="_blank">
                                <OverFlowTooltip
                                    value={`${0}社 (${0}社)`}
                                    className={'link-file-name'}
                                ></OverFlowTooltip>
                            </a>
                        </TableCell>
                        <TableCell className={classes.tableCellActionItemVersion}>
                            <div className="cell-version-status">
                                {getStatusItem(version, handleClickActionVersion)}
                                <Popover
                                    id={isShowActionVersion ? 'status-popover' : undefined}
                                    open={isShowActionVersion && actionVersionId === version.id}
                                    anchorEl={showActionVersion}
                                    onClose={handleCloseActionVersion}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center'
                                    }}
                                >
                                    <ul className="list-status-sale">
                                        <li
                                            className="item-status-selected"
                                            onClick={() =>
                                                onClickChangeStatusVersion(
                                                    setListVersionUpdated,
                                                    index,
                                                    listVersion,
                                                    setListVersion,
                                                    handleCloseActionVersion,
                                                    ProductManagementConstant.STATUS.ON_SALES,
                                                    version.status,
                                                    setIsEdit,
                                                    setEditionList
                                                )
                                            }
                                        >
                                            <span className="status-onsales status-sales">
                                                {I18n.get('CM-DROPDOWN-ON_SALE')}
                                            </span>
                                        </li>
                                        <li
                                            className="item-status-selected"
                                            onClick={() =>
                                                onClickChangeStatusVersion(
                                                    setListVersionUpdated,
                                                    index,
                                                    listVersion,
                                                    setListVersion,
                                                    handleCloseActionVersion,
                                                    ProductManagementConstant.STATUS.INACTIVE,
                                                    version.status,
                                                    setIsEdit,
                                                    setEditionList
                                                )
                                            }
                                        >
                                            <span className="status-inactive-sales status-sales">
                                                {I18n.get('CM-DROPDOWN-INACTIVE-SALE')}
                                            </span>
                                        </li>
                                        <li
                                            className="item-status-selected"
                                            onClick={() =>
                                                onClickChangeStatusVersion(
                                                    setListVersionUpdated,
                                                    index,
                                                    listVersion,
                                                    setListVersion,
                                                    handleCloseActionVersion,
                                                    ProductManagementConstant.STATUS.INTERNAL_SALE,
                                                    version.status,
                                                    setIsEdit,
                                                    setEditionList
                                                )
                                            }
                                        >
                                            <span className="status-internal-sales status-sales">
                                                {I18n.get('CM-DROPDOWN-INTERNAL-SALE')}
                                            </span>
                                        </li>
                                    </ul>
                                </Popover>
                            </div>

                            <IconButton
                                onClick={event =>
                                    handleClickActionVersion(event, `more-action-${version.id}`)
                                }
                            >
                                <img src="/assets/image/icon-nav-manage.svg" alt="" />
                            </IconButton>
                            <Popover
                                id={isShowActionVersion ? 'more-action-popover' : undefined}
                                open={
                                    isShowActionVersion &&
                                    actionVersionId === `more-action-${version.id}`
                                }
                                anchorEl={showActionVersion}
                                onClose={handleCloseActionVersion}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right'
                                }}
                            >
                                <ul>
                                    <li
                                        className="more-action-item-edition"
                                        onClick={() =>
                                            onOpenVersionList(
                                                {
                                                    editionId: edition.id,
                                                    productId: edition.productId,
                                                    nameProduct: nameProduct,
                                                    editionName: edition.name,
                                                    versionId: version.id,
                                                    isEditVersion: true
                                                },
                                                ProductManagementConstant.VERSION_LIST
                                            )
                                        }
                                    >
                                        <span className="item">
                                            <img src="/assets/image/edit-icon.svg" alt="" />
                                        </span>
                                        <span className="text">{I18n.get('USER01BTN007')}</span>
                                    </li>
                                    {version.status === ProductManagementConstant.STATUS.INACTIVE && (
                                        <li
                                            className="more-action-item-edition"
                                            onClick={() => {
                                                setShowPopUpDelete({ isOpen: true, index: index });
                                                handleCloseActionVersion();
                                            }}
                                        >
                                        <span className="item">
                                            <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                        </span>
                                        <span className="text">{I18n.get('USER01LB006')}</span>
                                        </li>
                                    )}
                                    
                                    <li
                                        className="more-action-item-edition"
                                        onClick={() =>
                                            onOpenVersionList(
                                                {
                                                    editionId: edition.id,
                                                    productId: edition.productId,
                                                    nameProduct: nameProduct,
                                                    editionName: edition.name,
                                                    versionId: version.id,
                                                    isDuplicateVersion: true
                                                },
                                                ProductManagementConstant.VERSION_LIST
                                            )
                                        }
                                    >
                                        <span className="item">
                                            <img src="/assets/image/icon-copy.svg" alt="" />
                                        </span>
                                        <span className="text">
                                            {I18n.get('CM-BUTTON-DUPLICATE')}
                                        </span>
                                    </li>
                                </ul>
                            </Popover>
                        </TableCell>
                    </TableRow>
                );
            })
        );
    };
    return (
        <div className="table-tbl table-tbl--account">
            <Table style={{ borderCollapse: 'separate', borderSpacing: 0, height: '100%' }}>
                <TableHead>
                    <TableRow>
                        <TableCell>{I18n.get('LABEL-TABLE-VERSION-NAME')}</TableCell>
                        <TableCell>{I18n.get('LABEL-TABLE-ORG-USAGE-STATUS')}</TableCell>
                        <TableCell>{I18n.get('CM-LABEL-TABLE-SALES-STATUS')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>{renderListVersion()}</TableBody>
            </Table>

            {/* dialog delete  */}
            <ConfirmDialog
                isOpen={showPopUpDelete.isOpen}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-PERMANENTLY').replace(
                    '{{item}}',
                    ProductManagementConstant.NAME.VERSION
                )}
                okCallBack={() =>
                    onDeletedVersionItem(
                        setListVersionUpdated,
                        showPopUpDelete.index,
                        listVersion,
                        setListVersion,
                        setIsEdit,
                        setShowPopUpDelete,
                        setEditionList
                    )
                }
                closeCallBack={() => setShowPopUpDelete({ isOpen: false })}
                textClose={I18n.get('COMBTN007')}
            />
        </div>
    );
}
